import { Modal, Form, Radio, Button } from "antd";
// import { PlusOutlined } from "@ant-design/icons";
// import useAuth from "@/hooks/useAuth";

const PromoOfferModal = ({ open, onClose, customer }) => {
  // Added 'customer' prop
  const [form] = Form.useForm();
  //   const user = useAuth();

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      // console.log("Selected offer:", values.promoOffer);
      // console.log(
      //   "Offering promo to customer:",
      //   customer?.full_name || customer?.id
      // );
      // Here you would typically send the selected offer to your backend
      // along with the customer.id or other relevant customer data
      onClose(); // Close the modal after submission
    } catch (error) {
      console.error("Validation failed:", error);
    }
  };

  return (
    <Modal
      open={open}
      onCancel={onClose}
      title={
        <div className="space-y-1">
          <h3 className="text-xl font-semibold text-gray-800">
            Offer a Coupon or Discount
          </h3>
          <p className="text-sm text-gray-500">
            Select one of the coupons or discount you wish to offer{" "}
            <span className="font-medium">
              {customer ? customer.full_name : "this customer"}
            </span>
          </p>
        </div>
      }
      footer={null}
      destroyOnClose
      maskClosable={false}
      width={520}
      centered
      className="p-4"
      closeIcon={
        <button className="ant-modal-close-x text-2xl" onClick={onClose}>
          &times;
        </button>
      }
    >
      <Form
        form={form}
        layout="vertical"
        className="mt-4"
        onFinish={handleSubmit}
      >
        <Form.Item
          name="promoOffer"
          rules={[{ required: true, message: "Please select an offer!" }]}
        >
          <Radio.Group className="w-full">
            <div className="flex flex-col gap-3">
              <Radio
                value="firstUserDiscount"
                className="w-full py-3 px-4 border rounded-lg hover:border-orange-500 transition-colors duration-200"
              >
                <span className="ml-2 text-base">
                  First User Discount 50% off
                </span>
              </Radio>
              <Radio
                value="megaSalesDiscount"
                className="w-full py-3 px-4 border rounded-lg hover:border-orange-500 transition-colors duration-200"
              >
                <span className="ml-2 text-base">
                  Mega Sales Discount 50% off
                </span>
              </Radio>
              <Radio
                value="flashSale"
                className="w-full py-3 px-4 border rounded-lg hover:border-orange-500 transition-colors duration-200"
              >
                <span className="ml-2 text-base">
                  Flash Sale: Buy One Get One Free
                </span>
              </Radio>
              <Radio
                value="seasonalClearance"
                className="w-full py-3 px-4 border rounded-lg hover:border-orange-500 transition-colors duration-200"
              >
                <span className="ml-2 text-base">
                  Seasonal Clearance: Up to 70% off
                </span>
              </Radio>
              <Radio
                value="exclusiveOffer"
                className="w-full py-3 px-4 border rounded-lg hover:border-orange-500 transition-colors duration-200"
              >
                <span className="ml-2 text-base">
                  Exclusive Offer: 30% for Members
                </span>
              </Radio>
            </div>
          </Radio.Group>
        </Form.Item>

        {/* Custom Footer */}
        <div className="flex justify-end gap-3 pt-6 border-t mt-6">
          <Button onClick={onClose} size="medium" className="px-6">
            Cancel
          </Button>
          <Button
            type="primary"
            htmlType="submit"
            size="medium"
            className="bg-orange-500 hover:bg-orange-600 focus:bg-orange-600 border-none px-6"
          >
            Offer
          </Button>
        </div>
      </Form>
    </Modal>
  );
};

export default PromoOfferModal;
